var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-subheader',[_vm._v("Outros Filtros")]),_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('status'),_c('ordination')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }